import { useChartIndicatorsStore } from './store';
import { subscribeToIndicatorsStorageChanges } from './storage';

export const initializeChartIndicatorsStore = () => {
  const loadIndicators = useChartIndicatorsStore.getState().loadIndicators;
  loadIndicators();

  // Cross-window sync: when another window (main app or chart popup) writes
  // indicators to localStorage, reload them here. loadIndicators only reads
  // storage and sets state (no save), so no feedback loop is possible.
  subscribeToIndicatorsStorageChanges(() => {
    useChartIndicatorsStore.getState().loadIndicators();
  });
};
